import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/organizations/$id')({
  params: {
    parse: (params) => {
      const id = Number.parseInt(params.id, 10)
      if (Number.isNaN(id) || params.id !== String(id)) {
        throw notFound()
      }
      return { id }
    },
    stringify: (params) => ({ id: String(params.id) }),
  },
  component: () => <Outlet />,
})
